var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBzFlame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.89 41.05A28.281 28.281 0 0140.47 64a24.55 24.55 0 002.65-11.54C43.12 46 41 40.44 38 37.6c-3 2.84-5.12 8.42-5.12 14.87A24.55 24.55 0 0035.53 64a28.28 28.28 0 01-11.42-22.95A38.998 38.998 0 0138 12c9.31 8.51 13.89 18.41 13.89 29.05z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/BZ_Flame.523e41e2.svg";
export { SvgBzFlame as ReactComponent };